'use strict';

angular.module('libraryModule')

.config(function (resourceStateProvider)
{
    const libraryState = resourceStateProvider.stateOptions.states['admin.media'];
    libraryState.title = 'LIBRARY';
})

.config(function (kdMediaProvider)
{
    kdMediaProvider.config('enableVideoPoster', false);
});
